import { toast } from "react-toastify";
import ProductModel from "../../Models/PorductModel";

const createProductKey = (product: any) => {
  let key = `id:${product.id}`;

  if (product.option && product.option.length > 0) {
    product.option.forEach((opt: any) => {
      key += `|option:${opt.option.id}`;
      if (opt.subOption) {
        key += `-subOption:${opt.subOption.id}`;
      }
    });
  }
  if (product && product.note) key += `|note:${product.note}`;
  return key;
};

export const AddToCart = ({
  element,
  params,
  navigate,
  t,
  quantity,
  handleAddedToCartNotice,
}: any) => {
  const cart =
    JSON.parse(localStorage.getItem(`cart${params.branch_id}`) ?? "[]") || [];

  const newProductKey = createProductKey(element);
  const existingProductIndex = cart.findIndex(
    (item: any) => createProductKey(item) === newProductKey
  );

  if (existingProductIndex !== -1) {
    cart[existingProductIndex].amount += quantity; // زيادة الكمية إذا كان المنتج موجودًا
  } else {
    cart.push({ ...element, amount: quantity });
  }

  localStorage.setItem(`cart${params.branch_id}`, JSON.stringify(cart));

  window.dispatchEvent(new Event("cart-updated"));
};

export const updateQuantity = (
  product: ProductModel,
  newQuantity: number,
  branch_id: number
) => {
  const cart =
    JSON.parse(localStorage.getItem(`cart${branch_id}`) ?? "[]") || [];

  const productKey = createProductKey(product);

  const updatedCart = cart.map((item: any) => {
    if (createProductKey(item) === productKey) {
      return { ...item, amount: newQuantity };
    }
    return item;
  });

  localStorage.setItem(`cart${branch_id}`, JSON.stringify(updatedCart));
  window.dispatchEvent(new Event("cart-updated"));
};
export const removeFromCart = (product: ProductModel, branch_id: number) => {
  const cart =
    JSON.parse(localStorage.getItem(`cart${branch_id}`) ?? "[]") || [];

  const productKey = createProductKey(product);

  const updatedCart = cart.filter(
    (item: any) => createProductKey(item) !== productKey
  );

  localStorage.setItem(`cart${branch_id}`, JSON.stringify(updatedCart));
  window.dispatchEvent(new Event("cart-updated"));
};

export const getCartItems = (branch_id: number) => {
  // استرجاع السلة من localStorage
  const cart = localStorage.getItem(`cart${branch_id}`);
  return cart ? JSON.parse(cart) : []; // إذا لم تكن السلة موجودة، تعيد مصفوفة فارغة
};

export const calculateTotal = (branch_id: number) => {
  // استرجاع السلة من localStorage
  const cart = localStorage.getItem(`cart${branch_id}`);
  const cartArray = cart ? JSON.parse(cart) : [];

  // حساب الإجمالي
  const total = cartArray.reduce((acc: number, item: any) => {
    // سعر المنتج الأساسي
    let itemTotal = item.price;

    // إضافة أسعار الخيارات المختارة
    if (item.option && item.option.length > 0) {
      item.option.forEach((opt: any) => {
        if (opt.subOption) {
          itemTotal += opt.subOption.price;
        }
      });
    }

    // مضاعفة المجموع حسب الكمية
    itemTotal *= item.amount;

    return acc + itemTotal;
  }, 0);

  return total;
};

export const CalcQuantity = (branch_id: number) => {
  const qantity = JSON.parse(
    localStorage.getItem("cart" + branch_id) ?? "[]"
  ).reduce((acc: number, item: any) => acc + item.amount, 0);

  return qantity;
};
